<template>
	<div class="not-found">
		<div class="error-message zw-orange-text">
			404
		</div>
		<div class="error">
			{{ $t('pages.notfound.not_found') }} <br />
			<a href="#" @click.prevent="goBack">{{ $t('pages.notfound.go_back') }}</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'NotFound',

		layout: 'default',

		methods: {
			goBack () {
				this.$router.push('/')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.not-found {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.error-message {
			margin: 2vw;
			font-size: 10vw;
			line-height: 10vw;
		}

		.error {
			margin: 2vw;
			font-size: 3vw;
			line-height: 4vw;
		}
	}
</style>




// WEBPACK FOOTER //
// src/pages/errors/NotFoundError.vue